import { Image } from 'lucide-react'

type Props = { props: Record<string, string | number | boolean> }

export function HeroPreview({ props: p }: Props) {
  return (
    <div className="text-center py-4 rounded bg-tf-bg-muted">
      {p.imageUrl ? (
        <img src={p.imageUrl as string} alt="Hero" className="w-full h-32 object-contain rounded mb-3" />
      ) : (
        <div className="w-full h-32 bg-tf-bg-hover rounded mb-3 flex items-center justify-center">
          <Image className="w-8 h-8 text-tf-text-muted" />
        </div>
      )}
      <h3 className="text-lg font-bold text-tf-text">{p.headline as string}</h3>
      <p className="text-sm text-tf-text-muted mt-1">{p.subheadline as string}</p>
    </div>
  )
}
